import Facebook from "./facebook.svg";
import EzLocal from "./ezlocal.svg";
import Google from "./google.svg";
import HibuReviews from "./hibu_review.png";
import Superpages from "./superpages.png";
import TripAdvisor from "./trip_advisor.svg";
import Foursquare from "./foursquare.svg";
import Insider from "./insiderpages.svg";
import Yellowpages from "./yp_com.svg";
import CitySearch from "./city_search.svg";
import Yahoo from "./yahoo.svg";
import ShowMeLocal from "./show_me_local.svg";
import MerchantCircle from "./merchant_circle.svg";
import Yelp from "./socialyelp.png";

export default {
  FIRST_PARTY: HibuReviews,
  FACEBOOK: Facebook,
  EZLOCAL: EzLocal,
  GOOGLE: Google,
  GOOGLEMYBUSINESS: Google,
  SUPERPAGES: Superpages,
  TRIPADVISORREVIEWS: TripAdvisor,
  FOURSQUARE: Foursquare,
  INSIDERPAGES: Insider,
  YPCOM: Yellowpages,
  CITYSEARCH: CitySearch,
  YAHOO: Yahoo,
  SHOWMELOCAL: ShowMeLocal,
  TRIPADVISOR: TripAdvisor,
  MERCHANTCIRCLE: MerchantCircle,
  YELP: Yelp,
};



// WEBPACK FOOTER //
// ./src/logos/social/index.js